<section class="container">
<div class="course-container" [dir]="language === 'ar' ? 'rtl' : 'ltr'">
  <div class="row details-card p-2 p-md-5">
    <div *ngIf="data" class="col-12 col-md-8 order-2 order-md-1">
      <h1>{{ data.titleTr }}</h1>
      <h6 class="discription">{{ data.summary }}</h6>
      <h6 class="mt-2">
        {{ "created_by" | translate }}:<span class="name">{{
          data.courseInfo.createdBy
        }}</span>
      </h6>
    </div>
    <div class="col-12 col-md-4 order-1 order-md-2 position-relative p-0">
      <video width="100%" controls muted *ngIf="data.video">
        <source [src]="data.video" type="video/mp4" />
        <source [src]="data.video" type="video/ogg" />
        <source [src]="data.video" type="video/x-ms-wmv" />
        <p>عذرًا، متصفحك لا يدعم تشغيل الفيديو.</p>
      </video>
      <img
        class="w-100 image"
        *ngIf="!data.video && data.imageUrl != ''"
        [src]="data.imageUrl"
      />

      <div class="d-none d-md-block">
        <ng-container *ngTemplateOutlet="priceCard"></ng-container>
      </div>
    </div>
    <div class="col-12 d-md-none mt-3 order-last p-0">
      <ng-container *ngTemplateOutlet="priceCard"></ng-container>
    </div>
  </div>

  <ng-template #priceCard>
    <div class="price-card w-100">
      <h4
        *ngIf="data.courseInfo.pricing"
        [ngClass]="{ 'sale-price': data.courseInfo.sales }"
      >
        {{ "price" | translate }} : {{ data.courseInfo.pricing }}
      </h4>
      <h4 *ngIf="data.courseInfo.sales">
        {{ "sale" | translate }} : {{ data.courseInfo.sales }}
      </h4>
      <button *ngIf="!isAlBorshama">
        <a href="https://wa.me/" target="_blank">
          <i class="bi bi-whatsapp fs-5"> {{ "contact_us" | translate }}</i>
        </a>
      </button>
      <button *ngIf="isAlBorshama" routerLink="/ar/course/{{ data.title }}">الاشتراك</button>
    </div>
  </ng-template>

  <div class="col-12 col-md-8 my-4 my-md-5 p-0">
    <div class="card">
      <h1>{{ "What_you'll_learn" | translate }}</h1>
      <div class="row mt-3">
        <div
          class="col-12 col-sm-6 align-items-center mb-2"
          *ngFor="let item of data.courseInfo.whatYouWillLearn"
        >
          <div class="row">
            <i class="bi bi-check2 col-auto"></i>
            <span class="col">{{ item.content }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h1>{{ "course_content" | translate }}</h1>
  <div class="accordion">
    <div
      *ngFor="let item of data.courseInfo.courseInclude"
      class="accordion-item"
    >
      <!-- Accordion Header -->
      <input type="checkbox" id="{{ item.title }}" />
      <label for="{{ item.title }}" class="accordion-header">
        {{ item.title }}
      </label>

      <!-- Accordion Content -->
      <div class="accordion-content">
        <div class="row my-3" *ngFor="let detail of item.details">
          <i class="bi bi-check2 col-auto"></i>
          <span class="col">{{ detail.content }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</section>